export default {
  ERROR_VERIFYING_HOMEOWNER_CONTACT: "There was an error verifying your contact information.",
};
